import { chakra, Popover } from '@chakra-ui/react';

import { AutocompleteContext } from './AutocompleteContext';
import { AutocompleteProps, useAutocomplete } from './useAutocomplete';

export function Autocomplete(
  props: React.PropsWithChildren<AutocompleteProps>
) {
  const context = useAutocomplete(props);
  const { isOpen, onClose, onOpen } = context;

  return (
    <AutocompleteContext.Provider value={context}>
      <Popover
        isOpen={isOpen}
        onClose={onClose}
        onOpen={onOpen}
        autoFocus={false}
        placement="bottom"
        closeOnBlur={true}
        matchWidth={true}
      >
        <chakra.div w="full">{props.children}</chakra.div>
      </Popover>
    </AutocompleteContext.Provider>
  );
}
